import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { studentActions } from '../actions/student.actions';
import { studentsActions } from '../../students/actions/students.actions';

@Injectable()
export class Student_StudentsEffects {
    private readonly actions = inject(Actions);

    getStudents$ = createEffect(() => {
        return this.actions.pipe(
            ofType(studentActions.addStudentSuccess, studentActions.updateStudentSuccess, studentActions.deleteStudentSuccess),
            map(() => {
                return studentsActions.reloadStudents();
            }),
        );
    });
}
